import HttpClient from '@seek/ca-http-client';
import { getDocumentUploadData as GET_DOCUMENT_UPLOAD_DATA } from '@seek/ca-myprofile-utils';

import { getOperationNameFromQuery } from 'src/modules/utils';

import { logError } from '../../modules/error-logger/browserLog';

import { generateUploadMetaData } from './generate-upload-metadata';

// Client to send simple http requests to upload files directly to blob store
// as blob does not have CORS enabled
const httpClient = new HttpClient({
  appName: 'SEEK JobApplyFrontend',
  trackingHeaders: false,
  omitXSeekSiteHeader: true,
  retryPolicy: {
    retries: 2,
  },
});

const getFormData = ({
  formFields,
  attachment,
}: {
  formFields: Array<Record<FormFields, string>>;
  attachment: File;
}) => {
  const formData = new FormData();

  formFields.forEach((field: { key: string; value: string }) => {
    if (field) {
      formData.append(field.key, field.value);
    }
  });

  formData.append('file', attachment);

  return formData;
};

type FormFields = 'key' | 'value';

export const uploadAttachmentToS3 = ({
  attachmentId,
  attachment,
}: {
  attachmentId: string;
  attachment: File;
}) =>
  generateUploadMetaData({ attachmentId })
    .then(({ url, formFields }) => {
      const data = getFormData({
        formFields,
        attachment,
      });

      return httpClient.send({
        url,
        method: 'post',
        data,
      });
    })
    .catch((err) => {
      logError(
        {
          stack: err.stack,
          message: err.message,
          type: 'generate-upload-metadata',
        },
        {
          error: err,
          attachmentId,
          operationName: getOperationNameFromQuery(GET_DOCUMENT_UPLOAD_DATA),
        },
      );
      throw err;
    });
